'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Layout from 'Layouts/Back';
import TextInput from 'Components/Forms/Elements/TextInput';
import DatePicker from 'Components/Forms/Elements/DatePicker';
import Dashboard from 'Components/Lists/Dashboard';
import PackOrderIndexRow from 'Components/Lists/Rows/PackOrderIndex';
import handleChange from 'Components/Forms/Functions/handleChange';
import Link from 'Pure/Link';
import bemit from 'Functions/bemit';
import { front_urls, URL } from 'Shared/Routes';
import { action } from 'Shared/Routes';
let app = window.app;
const header = [{
  name: 'code',
  label: 'Code',
  sortable: false
}, {
  name: 'created_at',
  label: 'Date acquisition',
  sortable: false
}, {
  name: 'expiration_date',
  label: 'Date Validité',
  sortable: false
}, {
  name: 'remaining_credit',
  label: 'Crédit restant',
  sortable: false
}, {
  name: 'bill',
  label: 'Facture PDF',
  sortable: false
}, {
  name: 'status',
  label: 'Statut',
  sortable: false
}];
const fields = header.map(infos => infos.name);

// Non-research like client picker, select, date picker, etc
const fields_without_timeout = [];
export default class MyPacksPage extends Component {
  state = {
    status_messages: {}
  };
  handleChange = handleChange.bind(this);
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const company_id = app?.state?.session?.user?.id;
    let filters = {
      start_date: state.start_date,
      end_date: state.end_date,
      company_id: company_id
    };
    let output = /*#__PURE__*/React.createElement(Layout, _extends({
      page_title: "Mes packs"
    }, props), /*#__PURE__*/React.createElement("div", {
      className: "o-content dashboard-page"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-filters c-filters--users"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(DatePicker, {
      onChange: component.handleChange,
      value: state['start_date'] || "",
      className: "cutom-date-picker",
      name: "start_date",
      label: "Date de d\xE9but",
      "allow-no-value": true,
      status: state.status_messages
    })), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(DatePicker, {
      onChange: component.handleChange,
      value: state['end_date'] || "",
      className: "cutom-date-picker",
      name: "end_date",
      label: "Date de fin",
      "allow-no-value": true,
      status: state.status_messages
    }))), /*#__PURE__*/React.createElement("div", {
      className: "dashboard-table u-margin-bottom-25",
      style: {
        overflow: 'initial'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-paper u-padding-top-0\r no-horizontal-padding"
    }, /*#__PURE__*/React.createElement(Dashboard, {
      model: "PackOrderIndex",
      url: action('getAllPackOrdersIndex'),
      header: header,
      fields: fields,
      component: PackOrderIndexRow,
      "order-by": "type",
      order: "asc",
      "items-per-page": 30,
      filters: filters
    })))));
    return output;
  }
}
